import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Login } from "../../components/Login";

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userType = searchParams.get('type') || 'pharmacy'; // Default to pharmacy

  const handleLogin = () => {
    // Navigation will be handled by the auth context
    
    navigate("/dashboard");
  };

  const handleNavigateToSignup = () => {
    navigate("/auth/signup");
  };

  const handleNavigateToForgotPassword = () => {
    navigate("/auth/forgot-password");
  };

  return (
    <Login
      onLogin={handleLogin}
      onNavigateToSignup={handleNavigateToSignup}
      onNavigateToForgotPassword={handleNavigateToForgotPassword}
      userType={userType as 'pharmacy' | 'admin'}
    />
  );
}
